import styled from 'styled-components'
import tw from 'twin.macro'

interface Props {
  disabled?: boolean
}

const StBaseInput = styled.input<Props>`
  ${({ disabled }) => disabled && tw`bg-neutral-200`}
`

export default StBaseInput
